import Typography, { TypographyProps } from '@mui/material/Typography';

export const SizedText = (props: TypographyProps) => {
    const { sx, children, ...rest } = props;
    return <Typography sx={{ ...sx, fontSize: { xs: 'small', md: 'initial' }}} { ...rest }>{children}</Typography>
}